import React, { useCallback, useMemo } from "react";
import { Typography, IconButton } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useStyles } from "src/pages/ServiceOrdersDetails/components/styles";
import { useSODetailsContext } from "src/providers/SODetailsStore";
import MonteraCard from "src/components/MonteraCard";
import { useAppContext } from "src/providers/AppProvider";
import EditIcon from "src/pages/ServiceOrdersDetails/components/icons/EditIcon";
import SpecialInstructionsIcon from "src/pages/ServiceOrdersDetails/components/icons/SpecialInstructionsIcon";
import { isIncompleteOrNewOrMissingInformation } from "src/utils/functions";

const SpecialInstructions = () => {
  const classes = useStyles();
  const { t } = useTranslation("orders");
  const {
    state: { user },
  } = useAppContext();
  const {
    serviceOrderDetails: { serviceOrder },
  } = useSODetailsContext();
  const {
    callAppAPI: { toggleModal },
  } = useAppContext();

  const handleSpecialInstructionsEdit = useCallback(() => {
    toggleModal({ id: "editSpecialInstrctionsSO", status: true });
  }, []);

  const disabledByStatus = useMemo(() => {
    return isIncompleteOrNewOrMissingInformation(serviceOrder?.statusMatchingName);
  }, [serviceOrder.statusMatchingName]);

  const isIntegrated = useMemo(() => !user?.partner?.isIntegration, [user?.partner?.isIntegration]);

  return (
    <MonteraCard
      headerIcon={<SpecialInstructionsIcon />}
      title={t("labels.summary_cards.special")}
      action={
        isIntegrated && disabledByStatus ? (
          <IconButton onClick={handleSpecialInstructionsEdit}>
            <EditIcon style={{ width: 16, height: 16 }} />
          </IconButton>
        ) : (
          <></>
        )
      }
    >
      <div className={classes.contentWrap}>
        <Typography variant="caption" className={classes.caption}>
          {t("labels.summary_cards.special")}
        </Typography>
        <Typography variant="body1" className={classes.description}>
          {serviceOrder.specialInstruction || `No Special Instructions`}
        </Typography>
      </div>
    </MonteraCard>
  );
};

export default SpecialInstructions;
